import React from 'react';
import { ButtonClean, Fieldset, InputUI, useModalContext } from '@fourthwall/components';
import { SelectTeamStaff } from '../../../SelectTeamStaff/SelectTeamStaff';
import { FormFields } from '../../hooks/useBadgeForm/types';
import { SelectedMember } from '../SelectedMember';
export const SelectedTeamMembers = ({ form, usersQuery }) => {
    const modal = useModalContext();
    const renderMembersList = () => {
        if (form.values.badgeType === 'Verified' && form.values.verifiedApplyToType !== 'Selected')
            return null;
        if (form.values.badgeType !== 'Verified' && !form.values.giveToSelectedTeamStaff)
            return null;
        if (!form.values.manuallyAssignedTeamStaff.length)
            return null;
        return (React.createElement(Fieldset.Row, { inner: true },
            React.createElement("div", { style: { width: '100%' } }, form.values.manuallyAssignedTeamStaff.map((email) => {
                const user = usersQuery?.data?.users.find((user) => user.email === email);
                return (React.createElement(SelectedMember, { key: email, nickname: user?.fullName || user?.email || email, onRemove: () => {
                        form.setFieldValue(FormFields.manuallyAssignedTeamStaff, form.values.manuallyAssignedTeamStaff.filter((teamStaff) => teamStaff !== email));
                    } }));
            }))));
    };
    const renderAddMembersButton = () => {
        if (form.values.badgeType === 'Verified' && form.values.verifiedApplyToType !== 'Selected')
            return null;
        if (form.values.badgeType !== 'Verified' && !form.values.giveToSelectedTeamStaff)
            return null;
        return (React.createElement(Fieldset.Row, { inner: true },
            React.createElement(ButtonClean, { label: "Add or remove internal team staff", onClick: () => modal.open(SelectTeamStaff, {
                    selectedTeamStaff: form.values.manuallyAssignedTeamStaff,
                    onSave: (selectedTeamStaff) => {
                        form.setFieldValue(FormFields.manuallyAssignedTeamStaff, selectedTeamStaff);
                    },
                }) })));
    };
    return (React.createElement(React.Fragment, null,
        renderMembersList(),
        renderAddMembersButton(),
        form.errors.manuallyAssignedTeamStaff &&
            typeof form.errors.manuallyAssignedTeamStaff === 'string' && (React.createElement(Fieldset.Row, { inner: true },
            React.createElement(InputUI.Error, { "$withoutMargin": true }, form.errors.manuallyAssignedTeamStaff)))));
};
